import React, { useState } from 'react';
import {
  Field, FieldInputProps, FieldMetaProps, FormikProps,
} from 'formik';
import InputMask from 'react-input-mask';
import classNames from 'classnames';

type Props = {
  // Пропсы от Formik
  field: FieldInputProps<any>;
  form: FormikProps<any>;
  meta: FieldMetaProps<any>;

  // Кастомные пропсы
  label: string,
  suffix?: React.ReactNode,
  isPhone?: boolean, // deprecated
  type: string,
  onRecoveryChange?: (value: string) => React.Dispatch<React.SetStateAction<string>>,
  errorName?: string,
  disableTouch?: boolean,
  isAutoFocus?: boolean,
  maxLength?: number,
  handleFocusField?: () => void,
  maskValue?: string,
};

const CustomTextField: React.FC<Props> = ({
  field,
  form: { handleChange, errors, touched, setFieldValue },
  ...props
}) => {
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const { label, type } = props;

  const onChange = (e: React.ChangeEvent) => {
    if (typeof props.onRecoveryChange === 'function') {
      const target = e.target as HTMLInputElement;
      props.onRecoveryChange(target.value);
    }
    handleChange(e);
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    if (props.maskValue !== "+7 (999) 999-99-99") {
      return;
    }
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text/plain");
    const digitsOnly = pastedText.replace(/^(\+7|8)|[^\d]/g, "");
    const formattedPhone = `+7 (${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6, 8)}-${digitsOnly.slice(8)}`;
    setFieldValue(field.name, formattedPhone);
  };

  const getCurrentField = () => {
    const {
      maskValue,
      isAutoFocus,
      maxLength,
    } = props;
    if (maskValue) {
      return (
        <InputMask
          type={type}
          id={field.name}
          name={field.name}
          mask={maskValue}
          autoComplete="none"
          className="custom-field__input gx-mb-0"
          value={field.value}
          onChange={onChange}
          onPaste={handlePaste}
          onFocus={() => {
            setIsFocused(true);
            if (props.handleFocusField) {
              props.handleFocusField();
            }
          }}
          onBlur={() => setIsFocused(false)}
          autoFocus={isAutoFocus}
        />

      );
    }
    return (
      <Field
        type={type}
        id={field.name}
        {...field}
        className="custom-field__input gx-mb-0"
        onFocus={() => {
          setIsFocused(true);
          if (props.handleFocusField) {
            props.handleFocusField();
          }
        }}
        onBlur={() => setIsFocused(false)}
        onChange={onChange}
        autoFocus={isAutoFocus}
        maxLength={maxLength}
      />
    );
  };

  const getObjValue = (obj?: anyObject, key?: string) => {
    if (!obj || !key) return false;
    return key.split('.').reduce((o, i) => {
      const curObj = (Array.isArray(o) && o.length) ? o[0] : o;
      return (curObj || {})[i];
    }, obj);
  };

  const currentField = getCurrentField();

  const {
    errorName,
    suffix,
    disableTouch,
  } = props;

  return (
    <>
      <div className={
                classNames(
                  'custom-field gx-flex-column', {
                    'is-filled': isFocused || field.value,
                    'is-focused': isFocused,
                    'is-error': (
                      !!getObjValue(errors, errorName ?? field.name)
                            && (disableTouch || getObjValue(touched, field.name))
                    ),
                  },
                )
            }
      >
        <label htmlFor={field.name} className="custom-field__label">{ label }</label>
        { currentField }
        { suffix }
      </div>
      {
        !!getObjValue(errors, errorName ?? field.name)
        && (disableTouch || getObjValue(touched, field.name))
        && (
          <div className="custom-field__error">
            { getObjValue(errors, errorName ?? field.name) }
          </div>
        )
      }
    </>
  );
};

export default CustomTextField;
